import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class MedicalCondition extends DynamicFieldsSerializer {
  namespace = 'enrolments';
}
